import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import Reflux from 'reflux';
import stateStore from '../stores/state-store';
import Touch from '../../touch';

const CLASS_NAME = 'slx-product-wizard-slider';
export default createReactClass({

	selectedFacet: null,
	currentItem: 0,

	propTypes: {
		children: PropTypes.node,
		goto: PropTypes.number,
		visible: PropTypes.bool
	},

	mixins: [
		Reflux.listenTo(stateStore, 'onWindowChange', 'onWindowChange')
	],

	getInitialState() {
		return {
			left: 0,
			itemWidth: 0
		};
	},

	componentDidMount() {
		Touch.add(this.refs.scroller, 'swiperight', () => this.goPrevious());
		Touch.add(this.refs.scroller, 'swipeleft', () => this.goNext());
	},

	onWindowChange(data) {
		this.setState({itemWidth: data.propWidth});
	},

	componentWillReceiveProps(props) {
		// console.log('componentWillReceiveProps', props.goto, this.props.goto, this.currentItem);
		if ((props.goto && props.goto !== this.props.goto)
			|| (props.goto !== null && props.goto !== this.currentItem)) {
			// console.log(this.getItems()[props.goto]);
			this.goToItem(this.getItems()[props.goto]);
		}
	},

	onPreviousClick(event) {
		if (!event.target.classList.contains('active') || !this.props.visible) {
			return;
		}
		event.stopPropagation();
		this.goPrevious();
	},

	onNextClick(event) {
		if (!event.target.classList.contains('active') || !this.props.visible) {
			return;
		}
		event.stopPropagation();
		this.goNext();
	},

	goPrevious() {
		const items = this.getItems();
		for (let i = items.length - 1; i >= 0; i--) {
			if (this.getItemLeft(items[i]) < 0) {
				this.goToItem(items[i]);
				break;
			}
		}
	},

	goNext() {
		const items = this.getItems();
		for (let i = 0; i < items.length; i++) {
			if (this.getItemLeft(items[i]) > 0) {
				this.goToItem(items[i]);
				break;
			}
		}
	},

	getItem(index) {
		return this.getItems()[index];
	},

	getItemIndex(item) {
		for (let i = 0; i < this.getItems().length; i++) {
			if (item === this.getItem(i)) {
				return i;
			}
		}
	},

	getItems() {
		return this.refs.scroller.children;
	},

	getItemLeft(item) {
		return item.getBoundingClientRect().left - this.refs.scrollerWrap.getBoundingClientRect().left;
	},

	goToItem(item) {
		let left = 0;
		for (let i = 0; i <= this.getItemIndex(item); i++) {
			let it = this.getItem(i);
			if (this.itemCanSlide(it)) {
				left = it.offsetLeft;
			} else {
				break;
			}
		}
		this.setState({left: -left});
		this.currentItem = this.getItemIndex(item);
	},

	itemCanSlide(item) {
		const left = typeof item === 'number'
			? item
			: -item.offsetLeft + this.getItemIndex(item) * 2; // Compensate the Math.Floor from width calculation
		return this.getScrollerWidth() + left >= this.refs.scrollerWrap.offsetWidth;
	},

	getScrollerWidth() {
		return this.state.itemWidth * this.props.children.length;
	},

	update(item) {
		const left = item ? -item.offsetLeft : 0;
		this.setState({
			left,
			atStart: left >= 0,
			atEnd: left + this.state.itemWidth * this.props.children.length <= this.refs.scrollerWrap.offsetWidth
		});
	},

	touch(type, callback) {
		Touch.add(this.refs.scroller, type, callback);
	},

	render() {
		let previous = {
			className: `${CLASS_NAME}__button ${CLASS_NAME}__button--previous`,
			ref: 'previous',
			onClick: this.onPreviousClick
		};
		let next = {
			className: `${CLASS_NAME}__button ${CLASS_NAME}__button--next`,
			ref: 'next',
			onClick: this.onNextClick
		};
		const scrollerWidth = this.getScrollerWidth();
		if (this.state.left < 0) {
			previous.className += ' active';
		}
		if (this.refs.scrollerWrap && this.itemCanSlide(this.state.left)) {
			next.className += ' active';
		}

		return (
			<div className={CLASS_NAME}>
				<div className={`${CLASS_NAME}__container`} ref="container">
					<button {...previous} />
					<button {...next} />
					<div className={`${CLASS_NAME}__scroller-wrap`} ref="scrollerWrap">
						<div
							className={`${CLASS_NAME}__scroller`}
							ref="scroller"
							style={{
								left: this.state.left
							}}
						>
							{React.Children.map(this.props.children, (child, index) => (
								<div className={`${CLASS_NAME}__item`} key={index}>
									{child}
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		);
	}

});
